import script from "./contract-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./contract-dialog.vue?vue&type=script&setup=true&lang=js"

import "./contract-dialog.vue?vue&type=style&index=0&id=14863c1b&lang=less&scoped=true"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14863c1b"]])

export default __exports__